import React from 'react';
import { Link } from 'react-router-dom';
import { T } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useStyles from './useStyles';
import COPY from './copy';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

export default function DiscountBanner(): JSX.Element {
  const { BannerContainer, DiscountLargeText, TryNowBox, ViewPlansButton, BannerRow } = useStyles();
  return (
    <Box display="flex" flexDirection="row" justifyContent="center" className={BannerRow} data-testid="DiscountBanner">
      <Box display="flex" flexDirection="row" className={BannerContainer} justifyContent="space-between">
        <Box display="flex" justifyContent="flex-end" alignItems="center">
          <Box display="flex" flexDirection="row" alignItems="center" className={DiscountLargeText}>
            <Typography>
              <T desc={COPY.DISCOUNT_TEXT} html /> <sup>1</sup>
            </Typography>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" className={TryNowBox} justifyContent="center" alignItems="center">
          <Link className={ViewPlansButton} to={`${ROOT_PRICING_ROUTE}/teams/details`}>
            <T desc={COPY.VIEW_PLANS_BUTTON} />
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
